import * as React from 'react';

import { useRecordContext } from 'react-admin';
import { Typography } from 'shared/mui/Typography';
import { User } from 'types/embedded/user';
import { formatInputInTz } from 'utils/date';

import { BoxStyled, ProfileBoxStyled } from './CommissionsCommentUser.styled';

type Props = {
  createdAt: string;
};

export const CommissionsCommentUser: React.FC<Props> = ({ createdAt }) => {
  const record = useRecordContext<User>();
  if (!record) {
    return <></>;
  }
  return (
    <BoxStyled>
      <ProfileBoxStyled>
        <Typography fontSize={14} fontWeight={500}>
          {record?.firstName} {record?.lastName}
        </Typography>
        <Typography color="secondary.main" fontSize={14} fontWeight={500}>
          &#183;
        </Typography>
        <Typography color="secondary.main" fontSize={14}>
          {formatInputInTz(createdAt, { format: 'dd.MM.yyyy, HH:mm:ss' })}
        </Typography>
      </ProfileBoxStyled>
    </BoxStyled>
  );
};
